import { useState } from "react";
import { fetchWithAuth } from "../../auth/auth";
import { getApiUrl } from "../../utils/getApiUrl";

type TranslationDirection = "en-pl" | "to-target" | null;

interface UseTranslationReturn {
  translating: TranslationDirection;
  translateToPl: (text: string) => Promise<string | null>;
  translateToTarget: (text: string, targetLang: string) => Promise<string | null>;
}

export const useTranslation = (): UseTranslationReturn => {
  const [translating, setTranslating] = useState<TranslationDirection>(null);

  const translate = async (
    text: string,
    targetLang: string,
    direction: "en-pl" | "to-target"
  ): Promise<string | null> => {
    if (!text.trim()) return null;

    setTranslating(direction);

    try {
      const response = await fetchWithAuth(getApiUrl("/tools/open-ai"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          text: `Translate this to ${targetLang}: "${text}". Return only the translation, nothing else.`,
        }),
      });
      const data = await response.json();
      return data.content ? data.content.trim() : null;
    } catch (err) {
      console.error(`Error translating to ${targetLang}:`, err);
      return null;
    } finally {
      setTranslating(null);
    }
  };

  return {
    translating,
    translateToPl: (text: string) => translate(text, "Polish", "en-pl"),
    translateToTarget: (text: string, targetLang: string) => translate(text, targetLang, "to-target"),
  };
};